import * as ReportGroupList from './types/ReportGroupList';

export * as State from 'containers/desktop/Reports/State';

export type Type = {
	reportGroups: ReportGroupList.Type;
	isDragOver: boolean;
	isLoading: boolean;
	search: string;
	status: string;
	page: number;
	totalReports: number;
	selectedMonth: string;
	filterMonth: string;
};

export function create(): Type {
	return {
		reportGroups: [],
		isDragOver: false,
		isLoading: false,
		search: '',
		status: 'all',
		page: 1,
		totalReports: 0,
		selectedMonth: '',
		filterMonth: '',
	};
}

export function setReportGroups(obj: Type, reportGroups: ReportGroupList.Type): Type {
	return { ...obj, reportGroups };
}

export function setIsDragOver(obj: Type, isDragOver: boolean): Type {
	return { ...obj, isDragOver };
}

export function setIsLoading(obj: Type, isLoading: boolean): Type {
	return { ...obj, isLoading };
}

export function setSearch(obj: Type, search: string): Type {
	return { ...obj, search };
}

export function setPage(obj: Type, page: number): Type {
	return { ...obj, page };
}

export function setTotalReports(obj: Type, totalReports: number): Type {
	return { ...obj, totalReports };
}

export function setStatus(obj: Type, status: string): Type {
	return { ...obj, status };
}

export function setSelectedMonth(obj: Type, selectedMonth: string): Type {
	return { ...obj, selectedMonth };
}

export function setFilterMonth(obj: Type, filterMonth: string): Type {
	return { ...obj, filterMonth };
}
